<template>
    <div>Discussions</div>
</template>

<script>
export default {
    name: 'ComplainDiscussion',
}
</script>
